import React from 'react'
import PropTypes from 'prop-types'

import Logo from 'components/atoms/Logo'
import SuccessIcon from 'components/atoms/SuccessIcon'
import ResetForm from 'components/organisms/ResetForm'
import FormResult from 'components/organisms/FormResult'
import FormHeading from 'components/molecules/FormHeading'

import { withStyles } from '@material-ui/core/styles'

export const styles = theme => ({
  root: {
    maxWidth: 405,
    height: '100vh',
    display: 'flex',
    margin: '0 auto',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: theme.spacing(2),
  },
  content: {
    textAlign: 'center',
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
})

const Reset = ({
  classes,
  errorMessage,
  onReset,
  hasError,
  goToLogin,
  resetSuccess,
}) => (
  <div className={classes.root}>
    <Logo className={classes.logo} />
    {resetSuccess ? (
      <div className={classes.content}>
        <SuccessIcon />
        <FormResult
          heading="Password reset requested"
          subHeading="A link to reset your password has been sent to your email address."
          onClick={goToLogin}
        />
      </div>
    ) : (
      <div>
        <FormHeading
          heading="Reset Password"
          subHeading="Reset your password using your email"
        />
        <ResetForm
          onReset={onReset}
          apiCallError={hasError}
          errorMessage={errorMessage}
        />
      </div>
    )}
  </div>
)

Reset.propTypes = {
  onReset: PropTypes.func,
  hasError: PropTypes.bool,
  goToLogin: PropTypes.func,
  resetSuccess: PropTypes.bool,
  errorMessage: PropTypes.string,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Reset)



// WEBPACK FOOTER //
// ./src/containers/account/ResetPassword/Reset.js